module.exports = __webpack_public_path__ + "static/media/Lightning_icon.785bab46.svg";